import { isSuccess } from '@yimoka/shared';

import { authAccountEntity } from '@/entities/auth-account';
import { getTenantID, setTenant } from '@/session/auth-session';

class WorkspaceBiz {
  getStores(tenantID: string) {
    return {
      personalMenuStore: authAccountEntity.getMyMenusStore(tenantID, 'personal'),
      tenantInfoStore: authAccountEntity.getTenantInfoStore(tenantID),
      workspaceMenuStore: authAccountEntity.getMyMenusStore(tenantID, 'workspace'),
    };
  }

  async mount(tenantID: string) {
    const stores = this.getStores(tenantID);
    // 租户工作台只装载工作台、个人中心和当前租户实体；管理台权限在进入 /admin 后单独获取。
    const [,, tenantInfoResponse] = await Promise.all([
      stores.workspaceMenuStore.fetch(),
      stores.personalMenuStore.fetch(),
      stores.tenantInfoStore.fetch(),
    ]);
    if (getTenantID() === tenantID && isSuccess(tenantInfoResponse) && tenantInfoResponse.data) {
      setTenant(tenantInfoResponse.data);
    }
  }
}

export const workspaceBiz = new WorkspaceBiz();
